// src/services/api/axios.ts
import axios from 'axios';

// สร้าง axios instance
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    // ดึง email จาก localStorage (หรือ sessionStorage)
    let email = null;
    try {
      const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        email = user.email;
      }
    } catch (e) {}
    // แนบ email ใน header ถ้ามี
    if (email) {
      config.headers = config.headers || {};
      config.headers['X-User-Email'] = email;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const code = error.response?.data?.details?.code;
    if (error.response?.status === 403 && code === 'jwt_auth_invalid_token') {
      window.dispatchEvent(new CustomEvent('session-expired'));
    }
    return Promise.reject(error);
  }
);